


















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { db } from '@/lib/ProductDatabase';
import PinPadComponent from '@/components/PinPadComponent.vue';
import { kioskSetup } from '@/lib/KioskSetup';
import Lockr from 'lockr';
import ServiceWorkerManager from '@/lib/util/ServiceWorkerManager';

@Component({
  components: {
    PinPadComponent,
  },
})
export default class Setup extends Vue {

  // reactive properties
  isUnlocked = false;
  isAutoUpdateEveryMinute = false;
  isDisableIdleTimer = false;
  updateCheckResult: string = '';

  // injected properties

  // non-reactive properties

  // watches
  @Watch('isAutoUpdateEveryMinute')
  onChangeIsAutoUpdateEveryMinute(newVal: boolean) {
    Lockr.set('kb_isAutoUpdateEveryMinute', newVal);
  }
  @Watch('isDisableIdleTimer')
  onChangeIsDisableIdleTimer(newVal: boolean) {
    Lockr.set('kb_isDisableIdleTimer', newVal);
  }

  // lifecycle
  created() {
    this.isAutoUpdateEveryMinute = Lockr.get('kb_isAutoUpdateEveryMinute', false);
    this.isDisableIdleTimer = Lockr.get('kb_isDisableIdleTimer', false);
  }

  // computed
  get kioskId(): string {
    return kioskSetup.kioskId.toString();
  }
  get userAgent(): string {
    return navigator.userAgent;
  }
  get devicePixelRatio(): number {
    return window.devicePixelRatio;
  }

  // methods
  btnExitSetup() {
    window.location.replace('/');
  }

  btnCheckForUpdate() {
    this.updateCheckResult = '';
    const workerManager = ServiceWorkerManager.instance();
    workerManager.whenReady()
    .then(() => {
      workerManager.checkForUpdate()
      .then((isUpdateFound: boolean) => {
        this.updateCheckResult = isUpdateFound ? "an update is available, will restart in a moment..." : "no update found";
        if ( isUpdateFound ) {
          setTimeout(() => {
            workerManager.activateWaitingWorker();
          }, 3000);
        }
      })
      .catch((err) => {
        this.updateCheckResult = err;
      });
    });
  }

  btnPreloadCache() {
    if ( 'serviceWorker' in navigator ) {
      const controller = navigator.serviceWorker.controller;
      if ( controller ) {
        controller.postMessage({
          name: 'preloadCache',
          list: db.getAllVideoFiles(),
          subpath: db.getWhitelabelPath(),
        });
      }
    }
  }

}

